import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FlatTab, FlatTabItem } from "@/components/FlatTab";
import { ROUTES } from "@/routes/paths";
import { PageTitle } from "@/components/PageTitle";
import { useProtectedNavigation } from "@/routes/useProtectedNavigation";

export const ManageProfile = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { navToRoute } = useProtectedNavigation();

  useEffect(() => {
    const path = location.pathname;
    const segments = path.split("/").filter((s) => s);
    const lastSegment = segments[segments.length - 1];

    if (lastSegment === ROUTES.MANAGE_PROFILE.BASE) {
      navToRoute("editProfile");
    }
  }, [location.pathname, navToRoute]);

  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes(ROUTES.MANAGE_PROFILE.YOUR_PROFILE))
      return ROUTES.MANAGE_PROFILE.YOUR_PROFILE;
    if (path.includes(ROUTES.MANAGE_PROFILE.CONTACT_INFO))
      return ROUTES.MANAGE_PROFILE.CONTACT_INFO;
    if (path.includes(ROUTES.MANAGE_PROFILE.FUN_FACTS))
      return ROUTES.MANAGE_PROFILE.FUN_FACTS;
    if (path.includes(ROUTES.MANAGE_PROFILE.NOTIFICATIONS))
      return ROUTES.MANAGE_PROFILE.NOTIFICATIONS;
    if (path.includes(ROUTES.MANAGE_PROFILE.PASSWORD))
      return ROUTES.MANAGE_PROFILE.PASSWORD;
    if (path.includes(ROUTES.MANAGE_PROFILE.SOCIALS))
      return ROUTES.MANAGE_PROFILE.SOCIALS;

    return ROUTES.MANAGE_PROFILE.YOUR_PROFILE;
  };

  const activeTab = getActiveTab();

  const tabItems: FlatTabItem[] = [
    {
      label: t("manageProfile.tabs.yourProfile"),
      active: activeTab === ROUTES.MANAGE_PROFILE.YOUR_PROFILE,
      route: "editProfile",
    },
    {
      label: t("manageProfile.tabs.funFacts"),
      active: activeTab === ROUTES.MANAGE_PROFILE.FUN_FACTS,
      route: "editFunFacts",
    },
    {
      label: t("manageProfile.tabs.socials"),
      active: activeTab === ROUTES.MANAGE_PROFILE.SOCIALS,
      route: "editSocials",
    },
    {
      label: t("manageProfile.tabs.contactInfo"),
      active: activeTab === ROUTES.MANAGE_PROFILE.CONTACT_INFO,
      route: "editContactInfo",
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <PageTitle title={t("manageProfile.title")} />

      <div className="ml-6">
        <FlatTab items={tabItems} />
      </div>

      <div className="w-full border-b border-border"></div>

      <div className="p-6">
        <Outlet />
      </div>
    </div>
  );
};
